import { useParams, Link } from "react-router-dom";
import { PawPrint, ArrowLeft } from "lucide-react";
import { useStore } from "../context/StoreContext";

const buildPages = (email, deliveryTime) => ({
  contacto: {
    title: "Contact",
    body: [
      `For any question about your order or about PeloCero, write to us at ${email}.`,
      "We usually reply within one business day.",
    ],
  },
  envios: {
    title: "Shipping Policy",
    body: [
      deliveryTime
        ? `Delivery time: ${deliveryTime}.`
        : "Delivery time: being confirmed with our logistics partner. We will update this page shortly.",
      "Shipping is free on orders of 2 or more units. Orders of 1 unit carry the shipping cost shown at checkout.",
      "We currently ship within the United States.",
    ],
  },
  devoluciones: {
    title: "Returns",
    body: [
      "If the product arrives defective or doesn't deliver what we promise, write to us and we'll arrange a return or replacement.",
      `[To be customized: return window, conditions and return address.]`,
      `Contact: ${email}.`,
    ],
  },
  privacidad: {
    title: "Privacy Policy",
    body: [
      "This page will describe how personal data is processed.",
      "[To be customized: data controller, purposes, legal basis, retention and user rights.]",
      `Contact: ${email}.`,
    ],
  },
  cookies: {
    title: "Cookie Policy",
    body: [
      "This site may use analytics and advertising cookies (for example, Meta Pixel and Google Analytics) when configured, for measurement and campaign improvement purposes.",
      "[To be customized: cookie list, purpose, duration and consent management.]",
    ],
  },
  terminos: {
    title: "Terms & Conditions",
    body: [
      "This page will contain the general terms of sale of PeloCero.",
      "[To be customized: seller identification, prices, payments, delivery, returns and applicable law.]",
    ],
  },
  "aviso-legal": {
    title: "Legal Notice",
    body: [
      "[To be customized: owner's identification details (name or company, tax ID, address) and website terms of use.]",
      `Contact: ${email}.`,
    ],
  },
});

export default function LegalPage() {
  const { slug } = useParams();
  const { config } = useStore();
  const email = config?.contact_email || "hola@pelocero.es";
  const pages = buildPages(email, config?.delivery_time);
  const page = pages[slug] || { title: "Page not found", body: ["The page you're looking for doesn't exist."] };

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-page-${slug}`}>
      <header className="border-b border-zinc-100">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="legal-logo">
            <span className="w-8 h-8 rounded-full bg-brand flex items-center justify-center">
              <PawPrint className="w-4 h-4 text-white" />
            </span>
            <span className="font-display font-bold text-lg">PeloCero</span>
          </Link>
          <Link to="/" data-testid="legal-back-link" className="text-sm text-zinc-500 hover:text-ink flex items-center gap-1.5">
            <ArrowLeft className="w-4 h-4" /> Back
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{page.title}</h1>
        <div className="mt-8 space-y-4">
          {page.body.map((p, i) => (
            <p key={i} className="text-sm sm:text-base text-zinc-600 leading-relaxed">{p}</p>
          ))}
        </div>
      </main>
    </div>
  );
}
